import React from 'react'
import { useState } from 'react'
import MyModal from '../../../../UI/modal/MyModal'
import EditIcon from '@mui/icons-material/Edit';
import { Tooltip } from '@mui/material'
import ChangeExpenseTypeForm from './ChangeExpenseTypeForm';
import ValueWithEdit from '../../../../UI/table/values/ValueWithEdit';

const ChangeExpenseTypeButton = ({ supplyBillItem }) => {

    const [open, setOpen] = useState(false)

  return (
    <>
        <ValueWithEdit
            value={supplyBillItem.expenseType ? supplyBillItem.expenseType.name : ''}
            textTooltip={'Редагувати'}
            setOpen={setOpen}
        />

        <MyModal
            open={open}
            setOpen={setOpen}
            header={'Редагування типу витрат'}
            disableClickOutside={true}
            content={
                <ChangeExpenseTypeForm
                    supplyBillItemBd={supplyBillItem}
                    setOpen={setOpen}
                />
            }
        />
    </>
  )
}

export default ChangeExpenseTypeButton